import React from "react";

/* Renders **bold**, *italic* and `code` as real formatting — no raw asterisks anywhere. */
export function renderInline(text) {
  if (!text) return text;
  const parts = String(text).split(/(\*\*[^*]+\*\*|\*[^*\n]+\*|`[^`\n]+`)/g);
  return parts.map((part, i) => {
    if (part.startsWith("**") && part.endsWith("**"))
      return <strong key={i} className="font-semibold">{part.slice(2, -2)}</strong>;
    if (part.startsWith("*") && part.endsWith("*") && part.length > 2)
      return <em key={i}>{part.slice(1, -1)}</em>;
    if (part.startsWith("`") && part.endsWith("`"))
      return <code key={i} className="px-1 rounded bg-[#26201612] text-[0.92em]">{part.slice(1, -1)}</code>;
    return part;
  });
}

/* Chat message renderer: headings, bullets and inline formatting, line by line. */
export function ChatText({ text }) {
  const lines = String(text || "").split("\n");
  return lines.map((line, i) => {
    const t = line.trim();
    if (t.startsWith("## ") || t.startsWith("### "))
      return <p key={i} className="font-semibold mt-2 mb-0.5">{renderInline(t.replace(/^#{2,3}\s/, ""))}</p>;
    if (/^[-*]\s+/.test(t))
      return (
        <span key={i} className="flex gap-2">
          <span className="shrink-0 mt-[8px] w-1 h-1 rounded-full bg-current opacity-60" />
          <span>{renderInline(t.replace(/^[-*]\s+/, ""))}</span>
        </span>
      );
    return <React.Fragment key={i}>{renderInline(line)}{i < lines.length - 1 ? "\n" : null}</React.Fragment>;
  });
}
